import { DivingIcon } from './DivingIcon';

/**
 * author: Google
 * id 813D489B-3127-4F32-9D6E-4BB8A6F51605
 * name diving
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/diving.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanDivingIcon = DivingIcon;
export default HumanDivingIcon